import type { CycleProps } from 'core/domains/user';

export function getNewCycle(nextCycle: number, cycles: CycleProps[]) {
  const onlyBoticarioCycles = cycles.filter((cycle) => cycle.brand === 'BOTICARIO');
  const newCycle = onlyBoticarioCycles.filter((cycle) => cycle.currentCycle === nextCycle)[0];

  return {
    currentCycle: newCycle.currentCycle,
    daysLeft: newCycle.daysLeft,
    daysTotal: newCycle.daysTotal,
    finalDate: newCycle.finalDate,
    initialDate: newCycle.initialDate,
    nextCycle: newCycle.currentCycle,
  };
}
